"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var IAdapter = /*#__PURE__*/function () {
  function IAdapter() {
    (0, _classCallCheck2["default"])(this, IAdapter);
  }
  return (0, _createClass2["default"])(IAdapter, [{
    key: "wrapEvent",
    value: function wrapEvent() {}
  }, {
    key: "buildAdapterLogLevels",
    value: function buildAdapterLogLevels() {}
  }, {
    key: "runProcessingQueue",
    value: function runProcessingQueue() {}
  }, {
    key: "listen",
    value: function listen() {}
  }, {
    key: "processMessage",
    value: function processMessage() {}
  }, {
    key: "addAttribute",
    value: function addAttribute() {}
  }, {
    key: "removeAttribute",
    value: function removeAttribute() {}
  }, {
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "decoratePayloadWithPrefix",
    value: function decoratePayloadWithPrefix() {}
  }]);
}();
module.exports = IAdapter;